import { useState } from 'react';

export default function Order() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    product: '',
    quantity: '1',
    pickup: '門市取貨',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const products = [
    'iPhone',
    'Samsung',
    'OPPO',
    '小米',
    'SONY',
    'VIVO',
    'Realme',
    'Asus',
    'Google',
    'B&O',
    'DangBei投影機',
    '充電頭',
    '充電線',
    '行動電源',
    '藍芽喇叭',
    '手機保護殼',
    '無線充電器',
    '其他配件'
  ];

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d4r7ea9antkh8cbet5h0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          phone: '',
          email: '',
          product: '',
          quantity: '1',
          pickup: '門市取貨',
          message: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="order" className="py-24 bg-gradient-to-br from-gray-50 to-slate-50">
      <div className="max-w-4xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            快速下單與取貨
          </h2>
          <p className="text-lg text-gray-600">
            線上下單，門市取貨，快速又方便
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8 lg:p-12">
          <form id="order-form" onSubmit={handleSubmit} data-readdy-form>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div>
                <label htmlFor="order-name" className="block text-sm font-medium text-gray-700 mb-2">
                  姓名 *
                </label>
                <input
                  type="text"
                  id="order-name"
                  name="name"
                  required
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-600 focus:border-transparent text-sm"
                  placeholder="請輸入您的姓名"
                />
              </div>

              <div>
                <label htmlFor="order-phone" className="block text-sm font-medium text-gray-700 mb-2">
                  聯絡電話 *
                </label>
                <input
                  type="tel"
                  id="order-phone"
                  name="phone"
                  required
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-600 focus:border-transparent text-sm"
                  placeholder="0912-345-678"
                />
              </div>
            </div>

            <div className="mb-6">
              <label htmlFor="order-email" className="block text-sm font-medium text-gray-700 mb-2">
                電子郵件
              </label>
              <input
                type="email"
                id="order-email"
                name="email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-600 focus:border-transparent text-sm"
                placeholder="example@email.com"
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div>
                <label htmlFor="order-product" className="block text-sm font-medium text-gray-700 mb-2">
                  選擇商品 *
                </label>
                <select
                  id="order-product"
                  name="product"
                  required
                  value={formData.product}
                  onChange={(e) => setFormData({ ...formData, product: e.target.value })}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-600 focus:border-transparent text-sm cursor-pointer"
                >
                  <option value="">請選擇商品</option>
                  {products.map((product) => (
                    <option key={product} value={product}>{product}</option>
                  ))}
                </select>
              </div>

              <div>
                <label htmlFor="order-quantity" className="block text-sm font-medium text-gray-700 mb-2">
                  數量 *
                </label>
                <input
                  type="number"
                  id="order-quantity"
                  name="quantity"
                  min="1"
                  max="10"
                  required
                  value={formData.quantity}
                  onChange={(e) => setFormData({ ...formData, quantity: e.target.value })}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-600 focus:border-transparent text-sm"
                />
              </div>
            </div>

            <div className="mb-6">
              <label htmlFor="order-pickup" className="block text-sm font-medium text-gray-700 mb-2">
                取貨方式 *
              </label>
              <select
                id="order-pickup"
                name="pickup"
                required
                value={formData.pickup}
                onChange={(e) => setFormData({ ...formData, pickup: e.target.value })}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-600 focus:border-transparent text-sm cursor-pointer"
              >
                <option value="門市取貨">門市取貨</option>
                <option value="宅配到府">宅配到府</option>
              </select>
            </div>

            <div className="mb-6">
              <label htmlFor="order-message" className="block text-sm font-medium text-gray-700 mb-2">
                備註說明
              </label>
              <textarea
                id="order-message"
                name="message"
                rows={4}
                maxLength={500}
                value={formData.message}
                onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-600 focus:border-transparent text-sm resize-none"
                placeholder="如有特殊需求請在此說明（限500字）"
              ></textarea>
              <p className="text-xs text-gray-500 mt-1">{formData.message.length}/500</p>
            </div>

            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full bg-teal-600 text-white py-4 rounded-lg font-medium hover:bg-teal-700 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed text-base whitespace-nowrap cursor-pointer"
            >
              {isSubmitting ? '送出中...' : '確認下單'}
            </button>

            {submitStatus === 'success' && (
              <div className="mt-6 bg-green-50 border border-green-200 text-green-800 px-4 py-3 rounded-lg text-sm">
                訂單已送出！我們將盡快與您聯繫確認訂單細節。
              </div>
            )}

            {submitStatus === 'error' && (
              <div className="mt-6 bg-red-50 border border-red-200 text-red-800 px-4 py-3 rounded-lg text-sm">
                送出失敗，請稍後再試或直接來電訂購。
              </div>
            )}
          </form>

          <div className="mt-8 pt-8 border-t border-gray-200">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
              <div>
                <i className="ri-store-2-line text-3xl text-teal-600 mb-2"></i>
                <h4 className="font-semibold text-gray-900 mb-1">門市取貨</h4>
                <p className="text-sm text-gray-600">當日下單，隔日取貨</p>
              </div>
              <div>
                <i className="ri-shield-check-line text-3xl text-teal-600 mb-2"></i>
                <h4 className="font-semibold text-gray-900 mb-1">品質保證</h4>
                <p className="text-sm text-gray-600">原廠公司貨，保固完整</p>
              </div>
              <div>
                <i className="ri-customer-service-line text-3xl text-teal-600 mb-2"></i>
                <h4 className="font-semibold text-gray-900 mb-1">售後服務</h4>
                <p className="text-sm text-gray-600">專業團隊，隨時協助</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
